import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'colorPickerValue', standalone: true, pure: true })
export class ColorPickerValuePipe implements PipeTransform {
  transform(color: string | null | undefined): string {
    return color?.replace(/^#/, '') ?? '';
  }
}
